<header class="app-header">
  <!-- Row 1: Sub-nav + Actions -->
  <div class="header-row header-row-main">
    <div class="header-left">
      @if (sidebarMode === 'closed') {
        <button type="button" class="header-menu-btn" aria-label="Ouvrir le menu de navigation" aria-haspopup="true"
                [attr.aria-expanded]="false" (click)="menuToggle.emit()">
          <ng-icon name="iconoirMenu" size="18"></ng-icon>
        </button>
      }
      @if (!subNav() && parentLink(); as parent) {
        <!-- Mobile : retour vers le maillon parent du fil d'Ariane. Seulement sans menu de module :
             sur 375 px, les deux côte à côte écrasaient le nom de la page à 0 px. -->
        <a class="header-back-btn" [routerLink]="parent.url" [attr.aria-label]="'Retour : ' + parent.label">
          <ng-icon name="iconoirArrowLeft" size="16" />
          <span>{{ parent.label }}</span>
        </a>
      }
      @if (subNav()) {
        <!-- Mobile: trigger button — porte le nom de la page courante -->
        <button type="button" class="sub-nav-mobile-trigger"
                [class.open]="showMobileNav()"
                aria-haspopup="true"
                [attr.aria-expanded]="showMobileNav()"
                [attr.aria-label]="'Navigation : ' + pageLabel()"
                (click)="toggleMobileNav()">
          <ng-icon name="iconoirNavArrowDown" size="14" />
          <span class="sub-nav-mobile-trigger__label">{{ pageLabel() }}</span>
        </button>

        <!-- Mobile: bottom-sheet drawer -->
        @if (showMobileNav()) {
          <div class="mobile-nav-backdrop" (click)="closeMobileNav()"></div>
          <nav class="mobile-nav-drawer">
            @for (item of subNav()!.items; track item.label) {
              @if (item.dividerBefore) {
                <div class="mobile-nav-divider"></div>
              }
              @if (item.children?.length) {
                <div class="mobile-nav-group">
                  <div class="mobile-nav-group-label">
                    @if (item.icon) {
                      <ng-icon [name]="item.icon" size="16" />
                    }
                    <span>{{ item.label }}</span>
                  </div>
                  @for (child of item.children; track child.label) {
                    @if (child.dividerBefore) {
                      <div class="mobile-nav-divider"></div>
                    }
                    <div class="sub-nav-child-row">
                      <button class="mobile-nav-item mobile-nav-child"
                              [class.active]="child.routerLink && isRouteActive(child.routerLink)"
                              (click)="onMobileNavItemClick(child)">
                        @if (child.icon) {
                          <ng-icon [name]="child.icon" size="16" />
                        }
                        <span>{{ child.label }}</span>
                        @if (child.badge && child.badge() > 0) {
                          <span class="sub-nav-badge">{{ child.badge() }}</span>
                        }
                      </button>
                      @if (child.quickAdd) {
                        <button type="button" class="sub-nav-quick-add sub-nav-quick-add--icon"
                                [attr.aria-label]="child.quickAdd.label" [title]="child.quickAdd.label"
                                (click)="runQuickAdd(child.quickAdd)">
                          <ng-icon name="iconoirPlus" size="15" />
                        </button>
                      }
                    </div>
                  }
                </div>
              } @else {
                <button class="mobile-nav-item"
                        [class.active]="(item.routerLink && isRouteActive(item.routerLink)) || (item.active && item.active())"
                        (click)="onMobileNavItemClick(item)">
                  @if (item.icon) {
                    <ng-icon [name]="item.icon" size="16" />
                  }
                  <span>{{ item.label }}</span>
                  @if (item.badge && item.badge() > 0) {
                    <span class="sub-nav-badge">{{ item.badge() }}</span>
                  }
                </button>
              }
            }
          </nav>
        }

        <!-- Desktop: pill sub-nav -->
        <nav class="sub-nav" data-tour="layout.subnav">
          @for (item of visibleItems(); track item.label) {
            @if (item.dividerBefore) {
              <div class="sub-nav-divider"></div>
            }
            @if (item.children?.length) {
              <div class="sub-nav-parent">
                <button class="sub-nav-tab sub-nav-tab-dropdown"
                        [class.active]="isParentActive(item)"
                        [class.open]="openSubMenu() === item.label"
                        (click)="toggleSubMenu(item.label)">
                  @if (item.icon) {
                    <ng-icon [name]="item.icon" size="15" />
                  }
                  <span>{{ item.label }}</span>
                  <ng-icon name="iconoirNavArrowDown" size="12" class="dropdown-chevron" [class.open]="openSubMenu() === item.label" />
                </button>
                @if (openSubMenu() === item.label) {
                  <div class="sub-nav-backdrop" (click)="closeSubMenu()"></div>
                  <div class="sub-nav-children">
                    @for (child of item.children; track child.label) {
                      @if (child.dividerBefore) {
                        <div class="sub-nav-child-divider"></div>
                      }
                      @if (child.action) {
                        <button class="sub-nav-child" (click)="child.action(); closeSubMenu()">
                          @if (child.icon) {
                            <ng-icon [name]="child.icon" size="15" />
                          }
                          <span>{{ child.label }}</span>
                          @if (child.badge && child.badge() > 0) {
                            <span class="sub-nav-badge">{{ child.badge() }}</span>
                          }
                        </button>
                      } @else {
                        <div class="sub-nav-child-row">
                          <a class="sub-nav-child" (click)="navigateChild(child)">
                            @if (child.icon) {
                              <ng-icon [name]="child.icon" size="15" />
                            }
                            <span>{{ child.label }}</span>
                            @if (child.badge && child.badge() > 0) {
                              <span class="sub-nav-badge">{{ child.badge() }}</span>
                            }
                          </a>
                          @if (child.quickAdd) {
                            <span class="sub-nav-quick-sep" aria-hidden="true"></span>
                            <button type="button" class="sub-nav-quick-add"
                                    [attr.aria-label]="child.quickAdd.label" [title]="child.quickAdd.label"
                                    (click)="runQuickAdd(child.quickAdd)">
                              <ng-icon name="iconoirPlus" size="13" />
                              <span>Ajouter</span>
                            </button>
                          }
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            } @else if (item.action) {
              <button class="sub-nav-tab sub-nav-tab-action"
                      [class.active]="item.active && item.active()"
                      (click)="item.action()">
                @if (item.icon) {
                  <ng-icon [name]="item.icon" size="15" />
                }
                <span>{{ item.label }}</span>
                @if (item.badge && item.badge() > 0) {
                  <span class="sub-nav-badge">{{ item.badge() }}</span>
                }
              </button>
            } @else {
              <!-- Une entrée qui fournit active() décide seule (ex. « Mon compte » sur toutes ses
                   sous-pages) : routerLinkActive retirerait sinon la classe posée ici. -->
              <a class="sub-nav-tab"
                 [routerLink]="item.routerLink"
                 [routerLinkActive]="item.active ? [] : 'active'"
                 [routerLinkActiveOptions]="{exact: item.exact ?? false}"
                 [class.active]="item.active && item.active()">
                @if (item.icon) {
                  <ng-icon [name]="item.icon" size="15" />
                }
                <span>{{ item.label }}</span>
                @if (item.badge && item.badge() > 0) {
                  <span class="sub-nav-badge">{{ item.badge() }}</span>
                }
              </a>
            }
          }
          <!-- Overflow "Plus" menu -->
          @if (overflowItems().length > 0) {
            <div class="sub-nav-parent">
              <button class="sub-nav-tab sub-nav-tab-dropdown"
                      [class.open]="showOverflow()"
                      (click)="toggleOverflow()">
                <ng-icon name="iconoirMoreHoriz" size="16" />
                <span>Plus</span>
              </button>
              @if (showOverflow()) {
                <div class="sub-nav-backdrop" (click)="closeOverflow()"></div>
                <div class="sub-nav-children">
                  @for (item of overflowItems(); track item.label) {
                    @if (item.dividerBefore) {
                      <div class="sub-nav-child-divider"></div>
                    }
                    <button class="sub-nav-child"
                            [class.active]="(item.routerLink && isRouteActive(item.routerLink)) || (item.active && item.active())"
                            (click)="onOverflowItemClick(item)">
                      @if (item.icon) {
                        <ng-icon [name]="item.icon" size="15" />
                      }
                      <span>{{ item.label }}</span>
                    </button>
                  }
                </div>
              }
            </div>
          }
          @if (subNav()!.extras) {
            <ng-container *ngTemplateOutlet="subNav()!.extras!" />
          }
        </nav>
      }
    </div>

    <div class="header-right">
      <!-- Date & heure en temps réel (masqué sur mobile) -->
      <span class="header-clock">
        <span class="header-clock-date">{{ currentDate() }}</span>
        <span class="header-clock-sep" aria-hidden="true">|</span>
        <ng-icon name="iconoirClock" size="13"></ng-icon>
        <span class="header-clock-time">{{ currentTime() }}</span>
      </span>

      @if (isVoiceEnabled()) {
        @if (subFeatures.voiceEnabled()) {
          <button
            type="button"
            class="header-icon-btn header-assistant-btn"
            aria-label="Ouvrir Koffi, votre assistant (bêta)"
            (click)="openVoiceOverlay()"
            [appTooltip]="'Koffi — votre assistant (bêta)'"
          >
            <ng-icon name="iconoirChatLines" size="18" />
            <span class="header-assistant-btn__beta" aria-hidden="true">bêta</span>
          </button>
        } @else {
          <button
            type="button"
            class="header-icon-btn header-voice-btn-disabled"
            aria-label="Koffi indisponible : module Assistant IA requis"
            [appTooltip]="'Koffi indisponible — module Assistant IA & Commandes Vocales requis'"
            disabled>
            <ng-icon name="iconoirChatLines" size="18" />
          </button>
        }
      }

      <!-- Animations avancées (goutte du thème, transitions de page, suppressions) -->
      <button
        type="button"
        class="header-icon-btn"
        [class.is-off]="!motion.enabled()"
        (click)="motion.toggle()"
        [attr.aria-pressed]="motion.enabled()"
        [attr.aria-label]="motion.enabled() ? 'Couper les animations' : 'Activer les animations'"
        [appTooltip]="motion.enabled() ? 'Animations activées — cliquer pour les couper' : 'Animations coupées — cliquer pour les activer'"
      >
        <ng-icon [name]="motion.enabled() ? 'iconoirFlash' : 'iconoirFlashOff'" size="18" />
      </button>

      <!-- Theme toggle -->
      <button
        type="button"
        class="header-icon-btn"
        data-tour="dashboard.home.theme"
        [attr.aria-label]="isDarkMode() ? 'Passer au thème clair' : 'Passer au thème sombre'"
        (click)="toggleTheme($event)"
        [appTooltip]="isDarkMode() ? 'Thème clair' : 'Thème sombre'"
      >
        @if (isDarkMode()) {
          <ng-icon name="iconoirHalfMoon" size="18" />
        } @else {
          <ng-icon name="iconoirSunLight" size="18" />
        }
      </button>

      <!-- Notifications (masquées pour les utilisateurs externes) -->
      @if (!authService.isExternalUser) {
      <div class="notification-container" data-tour="dashboard.home.notifications">
        <button
          type="button"
          class="header-icon-btn"
          [class.has-unread]="unreadCount() > 0"
          [attr.aria-label]="unreadCount() > 0 ? 'Notifications, ' + unreadCount() + ' non lue(s)' : 'Notifications'"
          aria-haspopup="true"
          [attr.aria-expanded]="showDropdown()"
          (click)="toggleDropdown()"
        >
          <ng-icon
            [name]="unreadCount() > 0 ? 'iconoirBellNotification' : 'iconoirBell'"
            size="18"
          />
          @if (unreadCount() > 0) {
            <span class="notification-badge">
              {{ unreadCount() > 99 ? '99+' : unreadCount() }}
            </span>
          }
        </button>

        @if (showDropdown()) {
          <div class="notification-dropdown">
            <div class="dropdown-header">
              <span class="dropdown-title">Notifications</span>
              @if (unreadCount() > 0) {
                <button class="mark-all-read" (click)="markAllAsRead()">
                  <ng-icon name="iconoirCheck" size="14" />
                  Tout marquer comme lu
                </button>
              }
            </div>

            <div class="notification-list">
              @if (notifications().length === 0) {
                <div class="empty-state">
                  <ng-icon name="iconoirBell" size="32" class="empty-state__icon" />
                  <span class="empty-state__text">Tout est à jour. Vos nouvelles notifications apparaîtront ici.</span>
                </div>
              } @else {
                @for (notification of notifications().slice(0, 10); track notification.id) {
                  <div class="notification-swipe-wrapper" [class.leaving]="isSwipeLeaving(notification.id)">
                    <div class="swipe-delete-bg" [class.armed]="isSwipeDeleteArmed(notification.id)">
                      <ng-icon name="iconoirTrash" size="16" />
                      <span>Supprimer</span>
                    </div>
                    <div
                      class="notification-item"
                      role="button"
                      tabindex="0"
                      [class.unread]="!notification.is_read"
                      [class.swipe-dragging]="isSwipeDragging(notification.id)"
                      [style.transform]="swipeTransform(notification.id)"
                      (pointerdown)="onNotificationPointerDown($event, notification)"
                      (pointermove)="onNotificationPointerMove($event)"
                      (pointerup)="onNotificationPointerUp($event)"
                      (pointercancel)="onNotificationPointerCancel($event)"
                      (click)="onNotificationClick(notification)"
                      (keydown)="onNotificationKeydown($event, notification)"
                    >
                      <div class="notification-icon" [class]="getModuleClass(notification.module)">
                        <ng-icon [name]="getIconName(notification.icon)" size="16" />
                      </div>
                      <div class="notification-content">
                        <span class="notification-title">{{ notification.title }}</span>
                        @if (notification.content) {
                          <span class="notification-desc">{{ notification.content }}</span>
                        }
                        <span class="notification-time">{{ getTimeAgo(notification.created_at) }}</span>
                      </div>
                      @if (!notification.is_read) {
                        <div class="unread-dot"></div>
                      }
                    </div>
                    <!-- Visible au survol et au focus clavier, en plus du glissement vers la droite. -->
                    <button type="button" class="notification-delete-btn"
                            aria-label="Supprimer la notification"
                            (click)="deleteNotification($event, notification)">
                      <ng-icon name="iconoirTrash" size="14" />
                    </button>
                  </div>
                }
              }
            </div>

            <div class="dropdown-footer">
              <a routerLink="/notifications" class="view-all-btn" (click)="showDropdown.set(false)">
                Voir toutes les notifications
                <ng-icon name="iconoirNavArrowRight" size="16" />
              </a>
              <a routerLink="/profile/notifications" class="email-prefs-link" (click)="showDropdown.set(false)">
                Gérer les e-mails que je reçois
              </a>
              @if (notifications().length > 0) {
                <button class="delete-all-btn" (click)="deleteAllNotifications()">
                  <ng-icon name="iconoirTrash" size="14" />
                  Supprimer toutes mes notifications
                </button>
              }
            </div>
          </div>
        }
      </div>
      }

      <!-- Logo de l'entreprise, tout à droite (MOKA-342) : version sombre en thème sombre si fournie. -->
      @if (orgLogoUrl(); as logo) {
        <img class="header-org-logo" [src]="logo" [alt]="orgLogos.organisationLabel()"
             [appTooltip]="orgLogos.organisationLabel()" (error)="orgLogoFailed.set(logo)" />
      }

    </div>
  </div>

  <!-- Row 2: Breadcrumb | Search + Actions -->
  <div class="header-row header-row-secondary" [class.is-bare]="secondaryBare() && !secondaryPending()"
       [class.is-pending]="secondaryPending()"
       [class.is-home]="homeRow()">
    <div class="header-breadcrumb">
      <app-breadcrumb />
    </div>
    <div class="header-right-group">
      @if (headerSearch()) {
        <div class="header-search">
          <ng-container *ngTemplateOutlet="headerSearch()"></ng-container>
        </div>
      }
      @if (headerContent()) {
        <div class="header-actions">
          <ng-container *ngTemplateOutlet="headerContent()"></ng-container>
        </div>
      }
    </div>
  </div>

</header>
